import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_date_pager = _resolveComponent("date-pager")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_page_title, { value: "クラス日誌" }),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          color: "black",
          class: "mx-2",
          variant: "outlined"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-printer", -1)
              ]))]),
              _: 1
            }),
            _cache[1] || (_cache[1] = _createTextVNode(" 印刷 ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          color: "primary",
          class: "mx-2",
          variant: "outlined"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("下書き保存", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          color: "primary",
          class: "ml-2",
          variant: "flat"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("申請", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_date_pager, { class: "pt-4" })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, {
      fluid: "",
      class: "pt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "pb-2" }, "ねらい", -1)),
                _createVNode(_component_v_textarea, { variant: "outlined" })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "pb-2" }, "活動内容", -1)),
                _createVNode(_component_v_text_field, {
                  variant: "outlined",
                  label: "午前"
                }),
                _createVNode(_component_v_text_field, {
                  variant: "outlined",
                  label: "午後"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "pb-2" }, "評価と反省", -1)),
                _createVNode(_component_v_textarea, { variant: "outlined" })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "6" }, {
              default: _withCtx(() => [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "pb-2" }, "保護者支援", -1)),
                _createVNode(_component_v_textarea, { variant: "outlined" })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}